// Import React library for JSX support
import React from 'react';
// Import ReactDOM for rendering React components in the browser
import ReactDOM from 'react-dom/client';
// Import global styles
import './index.css';
// Import our main App component
import App from './App';
// Import performance monitoring utility
import reportWebVitals from './reportWebVitals';

// Create a root React element in the DOM
// This targets the 'root' div in public/index.html
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render our app inside React's StrictMode
// StrictMode helps identify potential problems in the application
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
